// extracted by mini-css-extract-plugin
export default {"block":"srOLl","divider":"g8QXi"};